
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/mobile/handsets",
      function () {
        return require("private-next-pages/shop/mobile/handsets/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/mobile/handsets"])
      });
    }
  